import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import Tooltip from '../Tooltip';
import Icon from '../Icon';
import Progress from '../Progress';
import classNames from 'classnames';

var FileSvg = function FileSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "32",
    height: "32",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null)), /*#__PURE__*/React.createElement("path", {
    d: "M7.333 4.667v22.666h17.334V9.495l-4.829-4.828H7.333zM6 2.667h14.667l6 6v20a.667.667 0 0 1-.667.666H6a.667.667 0 0 1-.667-.666V3.333A.667.667 0 0 1 6 2.667zM10.667 10h6.666v2h-6.666v-2zm0 4.667h10.666v2H10.667v-2zm0 4.666h10.666v2H10.667v-2z"
  }));
};

var PreviewIcon = function PreviewIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "64 64 896 896",
    style: {
      color: '#fff',
      marginRight: '10px'
    },
    focusable: "false",
    className: "",
    "data-icon": "eye",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
  }));
};

var FileShowCard = /*#__PURE__*/function (_React$Component) {
  _inherits(FileShowCard, _React$Component);

  var _super = _createSuper(FileShowCard);

  function FileShowCard() {
    var _this;

    _classCallCheck(this, FileShowCard);

    _this = _super.apply(this, arguments);

    _this.onLoaderError = function (file) {
      file.loadFail = true;

      _this.forceUpdate();
    };

    _this.renderUploadFailFile = function (file) {
      return /*#__PURE__*/React.createElement("span", {
        className: "roo-upload-card-file roo-upload-card-file-error"
      }, /*#__PURE__*/React.createElement(FileSvg, null), /*#__PURE__*/React.createElement("span", null, file.name));
    };

    _this.renderSuccess = function (file) {
      return /*#__PURE__*/React.createElement("img", {
        src: file.url || file.previewUrl,
        alt: "",
        onError: function onError() {
          _this.onLoaderError(file);
        },
        className: "roo-upload-card-img"
      });
    };

    _this.renderLoadFailFile = function (file) {
      return /*#__PURE__*/React.createElement("span", {
        className: "roo-upload-card-file roo-upload-card-file-success"
      }, /*#__PURE__*/React.createElement(FileSvg, null), /*#__PURE__*/React.createElement("span", null, file.name));
    };

    _this.renderUploadingFile = function (file) {
      var percent = Math.round(file.percent || 0);
      return /*#__PURE__*/React.createElement("span", {
        className: "roo-upload-card-file roo-upload-card-file-loading"
      }, /*#__PURE__*/React.createElement(Progress, {
        animation: true,
        animationDuration: 1,
        percentage: percent
      }), /*#__PURE__*/React.createElement("span", null, file.name));
    };

    _this.renderCardItem = function (file) {
      if (file.status === 'success' && file.loadFail) {
        return _this.renderLoadFailFile(file);
      }

      switch (file.status) {
        case 'fail':
          return _this.renderUploadFailFile(file);

        case 'uploading':
          return _this.renderUploadingFile(file);

        case 'success':
          return _this.renderSuccess(file);

        default:
          return null;
      }
    };

    _this.renderFileLoad = function () {
      var _this$props = _this.props,
          renderLoader = _this$props.renderLoader,
          canDrop = _this$props.canDrop;
      var loader = renderLoader();
      if (!loader) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames('roo-upload-card-item', 'roo-upload-card-item-load', {
          'roo-upload-card-item-canDrop': canDrop
        })
      }, loader);
    }; // @ts-ignore


    _this.renderPreview = function (file) {
      if (file.status !== 'success') return null;
      var isShowPreview = _this.props.isShowPreview;
      if (!isShowPreview) return null;
      return /*#__PURE__*/React.createElement("span", {
        onClick: function onClick() {
          _this.props.onPreview(file);
        },
        style: {
          display: 'flex',
          alignItems: 'center'
        }
      }, "  ", /*#__PURE__*/React.createElement(PreviewIcon, null));
    };

    _this.renderFilelist = function () {
      var _this$props2 = _this.props,
          fileList = _this$props2.fileList,
          onFileRemove = _this$props2.onFileRemove,
          disabled = _this$props2.disabled,
          renderCustomCard = _this$props2.renderCustomCard,
          customCardClassName = _this$props2.customCardClassName;
      return fileList.map(function (file, index) {
        var isError = file.status === 'fail';
        var cardElement = /*#__PURE__*/React.createElement(Tooltip, {
          placement: "top",
          content: file.errorInfo,
          key: file.uid
        }, /*#__PURE__*/React.createElement("div", {
          className: classNames('roo-upload-card-item', {
            'roo-upload-card-item-error': isError
          })
        }, _this.renderCardItem(file), /*#__PURE__*/React.createElement("div", {
          className: classNames('roo-upload-card-mask')
        }, _this.renderPreview(file), disabled ? null : /*#__PURE__*/React.createElement(Icon, {
          name: "trash-o",
          color: "#fff",
          size: 20,
          onClick: function onClick() {
            onFileRemove(file);
          }
        })))); //支持预览已上传文件时可修改要展示的dom

        if (typeof renderCustomCard === 'function') {
          var itemDom = renderCustomCard(file, index);
          return /*#__PURE__*/React.createElement("div", {
            className: customCardClassName
          }, cardElement, itemDom);
        }

        return cardElement;
      });
    };

    return _this;
  }

  _createClass(FileShowCard, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      // 更新的时候判断,如果是本地对象则需要转换成dataUrl
      var fileList = this.props.fileList;
      var localFileList = fileList.filter(function (file) {
        return file._fileObj;
      }).filter(function (file) {
        return file.previewUrl === undefined;
      }).filter(function (file) {
        return file.status === 'success';
      });
      var loadPromiseList = localFileList.map(function (file) {
        return new _Promise(function (res, rej) {
          var fileReader = new FileReader(); // @ts-ignore

          fileReader.readAsDataURL(file._fileObj);

          fileReader.onload = function () {
            return res({
              dataUrl: fileReader.result,
              file: file
            });
          }; // eslint-disable-next-line prefer-promise-reject-errors


          fileReader.onerror = function (error) {
            return rej({
              error: error,
              file: file
            });
          };
        });
      });
      loadPromiseList.forEach(function (promise) {
        promise.then(function (_ref) {
          var dataUrl = _ref.dataUrl,
              file = _ref.file;
          file.previewUrl = dataUrl;

          _this2.forceUpdate();
        }).catch(function (_ref2) {
          var file = _ref2.file;
          file.previewUrl = '';
          file.loadFail = true;

          _this2.forceUpdate();
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var fileList = this.props.fileList;
      if (!fileList || fileList.length === 0) return this.renderFileLoad();
      return /*#__PURE__*/React.createElement("div", {
        className: "roo-upload-card-container"
      }, this.renderFilelist(), this.renderFileLoad());
    }
  }]);

  return FileShowCard;
}(React.Component);

export default FileShowCard;